<app-project-resource-items class="flex-column flex-fill flex-100"
  [iProjectId]="projectTab().ProjectId"
  [iProjectTypeId]="projectTab().ProjectTypeId">
</app-project-resource-items>